import WorkflowsListing from '@/components/workflows/WorkflowsListing';
import WorkflowEditor from '@/components/workflows/WorkflowEditor';
import WorkflowLog from '@/components/workflows/WorkflowLog';
import WorkflowNodeSettings from '@/components/workflows/WorkflowNodeSettings';
import WorkflowImport from "@/components/workflows/WorkflowImport";
import WhatsNew from "@/components/misc/WhatsNew";
import Integrations from "@/components/misc/Integrations";

export const ROUTES = [
    {
        path: '',
        component: WorkflowsListing,
        children: [
            {
                name: 'import',
                path: 'import',
                props: true,
                component: WorkflowImport
            },
            {
                name: 'what-is-new',
                path: 'what-is-new',
                props: true,
                component: WhatsNew
            },
            {
                name: 'integrations',
                path: 'integrations',
                props: true,
                component: Integrations
            }
        ]
    },
    {
        name: 'editor',
        path: '/workflow/:uid',
        component: WorkflowEditor,
        props: true,
        children: [
            {
                name: 'viewLog',
                path: 'logs',
                props: true,
                component: WorkflowLog,
            },
            {
                name: 'nodeSettings',
                path: 'node/:nodeUid',
                props: true,
                component: WorkflowNodeSettings,
            },
        ],
    },
];
